module.exports = __webpack_public_path__ + "img/icon-question-rating-skin-heart.987ffaa2.svg";